import { Link } from 'react-router-dom';

export const PrivacyPolicyPage = () => {
  return (
    <main className="pt-20" data-testid="privacy-policy-page">
      {/* Page Header */}
      <section className="page-header py-16 lg:py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="text-center">
            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-amber-950 font-serif mb-4">
              Privacy Policy
            </h1>
            <p className="text-stone-600">Last updated: December 2024</p>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 section-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="prose prose-stone prose-lg max-w-none">
            <h2 className="text-2xl font-semibold text-amber-950 font-serif mb-4">1. Introduction</h2>
            <p className="text-stone-600 mb-6">
              Buy Fusion ("we," "our," or "us") respects your privacy and is committed to protecting your personal information. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website or use our flooring installation services.
            </p>

            <h2 className="text-2xl font-semibold text-amber-950 font-serif mb-4">2. Information We Collect</h2>
            <p className="text-stone-600 mb-4">We may collect the following types of information:</p>
            <ul className="list-disc list-inside text-stone-600 mb-6 space-y-2">
              <li><strong>Personal Information:</strong> Name, email address, phone number, and mailing address when you contact us or request an estimate.</li>
              <li><strong>Project Information:</strong> Details about your flooring project, property type, and service preferences.</li>
              <li><strong>Usage Data:</strong> Information about how you interact with our website, including IP address, browser type, and pages visited.</li>
              <li><strong>Communication Data:</strong> Records of correspondence when you contact us.</li>
            </ul>

            <h2 className="text-2xl font-semibold text-amber-950 font-serif mb-4">3. How We Use Your Information</h2>
            <p className="text-stone-600 mb-4">We use your information to:</p>
            <ul className="list-disc list-inside text-stone-600 mb-6 space-y-2">
              <li>Provide and improve our flooring services</li>
              <li>Respond to your inquiries and provide estimates</li>
              <li>Schedule appointments and manage projects</li>
              <li>Send service-related communications</li>
              <li>Process payments and maintain records</li>
              <li>Comply with legal obligations</li>
            </ul>

            <h2 className="text-2xl font-semibold text-amber-950 font-serif mb-4">4. Information Sharing</h2>
            <p className="text-stone-600 mb-6">
              We do not sell your personal information. We may share your information with trusted service providers who assist in our operations, or when required by law. We ensure all third parties maintain appropriate security measures.
            </p>

            <h2 className="text-2xl font-semibold text-amber-950 font-serif mb-4">5. Data Security</h2>
            <p className="text-stone-600 mb-6">
              We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the Internet is 100% secure.
            </p>

            <h2 className="text-2xl font-semibold text-amber-950 font-serif mb-4">6. Your Rights</h2>
            <p className="text-stone-600 mb-4">You have the right to:</p>
            <ul className="list-disc list-inside text-stone-600 mb-6 space-y-2">
              <li>Access and receive a copy of your personal information</li>
              <li>Request correction of inaccurate information</li>
              <li>Request deletion of your information</li>
              <li>Opt-out of marketing communications</li>
            </ul>

            <h2 className="text-2xl font-semibold text-amber-950 font-serif mb-4">7. Cookies</h2>
            <p className="text-stone-600 mb-6">
              Our website may use cookies to enhance your browsing experience. You can control cookie settings through your browser preferences.
            </p>

            <h2 className="text-2xl font-semibold text-amber-950 font-serif mb-4">8. Contact Us</h2>
            <p className="text-stone-600 mb-6">
              If you have questions about this Privacy Policy or wish to exercise your rights, please contact us at:
            </p>
            <div className="bg-stone-50 rounded-xl p-6 mb-6">
              <p className="text-stone-700">
                <strong>Buy Fusion - Premium Flooring Co.</strong><br />
                88 Sunset Boulevard<br />
                Los Angeles, CA 800134<br />
                Email: <a href="mailto:support@buyfusion.store" className="text-amber-600 hover:text-amber-700">support@buyfusion.store</a><br />
                Phone: <a href="tel:+18888791244" className="text-amber-600 hover:text-amber-700">+1-888-879-1244</a>
              </p>
            </div>

            <h2 className="text-2xl font-semibold text-amber-950 font-serif mb-4">9. Changes to This Policy</h2>
            <p className="text-stone-600 mb-6">
              We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last updated" date.
            </p>
          </div>

          <div className="mt-12 pt-8 border-t border-stone-200">
            <Link to="/" className="text-amber-600 hover:text-amber-700 font-medium">
              ← Back to Home
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
};

export default PrivacyPolicyPage;
